import { MapSideBarData } from '@/_helpers';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import { AppMenuitemComponent } from './app.menuitem.component';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppMenuitemComponent]
})
export class AppMenuComponent implements OnInit {
  readonly model = signal<MenuItem[]>([]);

  readonly layoutService = inject(LayoutService);
  private readonly mapSideBarData = inject(MapSideBarData);
  private readonly destroyRef = inject(DestroyRef);
  readonly translate = inject(TranslateService);

  ngOnInit(): void {
    this.mapSideBarData
      .initLoad()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((items) => {
        this.model.set([
          {
            label: '',
            items
          }
        ]);
      });
  }
}
